const BOOL4_OPTIONS = {
  yes: 'Yes',
  no: 'No',
  na: 'N/A',
  unknown: 'Unknown',
} as const;

export default BOOL4_OPTIONS;
